import React from "react";
import Header from "./Header";
import ContactUs from "./contactUs";
import NotFound404 from "../../images/NoMatch404.jpg";

class NoMatch404 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <div>
                <Header title={'Engineering Guru'} subTitleText={"An initiative to provide effective guidance to upcoming engineering graduates to help them learn, define and drive their career in a successful manner"}/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <h2>Page Not Found</h2>
                            <hr />
                            <p>Looks like, you lost your way in finding some page.</p>
                            <p>Please use Navigation at the top of this page to get back to Home safely</p>
                            <img src={NotFound404}  alt={"Not Found 404"} />
                        </div>
                        <div className="col-md-4">
                            <ContactUs />
                        </div>
                    </div>
                </div>
                <hr style={{padding: "0.3em"}}/>
            </div>
        );
    }
}

NoMatch404.propTypes = {};

export default NoMatch404;
